<template>
  <div class="text-item-content">
    <div class="text-title">{{title}}</div>
    <div class="text-content">{{value}}</div>
  </div>
</template>

<script>

import { isObject , isArray }  from "@/utils/types"
export default {
  uuid: "00000000-0000-0000-0000-000000000009",
  components: {},
  props: [
    'datamodel',
  ],
  data() {
    return {
      
    }
  },
  computed: {
    title() {
      if(this.$i18n.locale == 'zh-CN'){
        return this.datamodel.zhlabel  
      }else{
        return this.datamodel.enlabel
      }
    },
    value() {
      if(this.datamodel && this.datamodel.value  && isArray(this.datamodel.value)){
        return this.datamodel.value.join(',')
      }
      return this.datamodel.value 
    }
  },
  methods: {
    
  },
  created() {},
  mounted() {
    console.log("value:", this.datamodel.value)
    console.log("model:", this.datamodel)
  }
}
</script>
<style lang="scss" scoped>

.text-item-content {
  margin: 16px 0;
  text-align: left;
  display: flex;

  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #000000;

  .text-title {
    letter-spacing: 0em;
    text-align: left;
    color: #8C8C8C;
    width: 120px;
    overflow: hidden;
    margin-right: 8px;
  }
  .text-content {
    flex: 1;
    letter-spacing: 0em;
    text-align: left;
    overflow: hidden;
  }
}
</style>
